import React, { useContext, useEffect } from "react";
import Loading from "./loading";
import authContext from "../../contexts/auth/authContext";
import { useLocation } from "react-router-dom";

const Callback = () => {
    const location = useLocation();
    const auth = useContext(authContext);

    useEffect(() => {
        if (/access_token|id_token|error/.test(location.hash)) {
            auth.handleAuthentication();
        }
    }, []);

    return <Loading />;
};

export default Callback;
